import React from 'react';
import { Form, Checkbox, Tooltip } from '../../../../../components';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { NameField, UsernameField } from '../../cloudAccountFields';
import { TestConnectionButton } from '../../cloudAccountFields';
import TagsSelector from '../../../../TagsSelector';
import { getHelpLink, getPrivateDeploymentCloud } from '../../utils/cloudAccountHelpers';
import { isAWS } from '../../../../../constants';
import './AWSCloudAccount.scss';

/**
 * AWS Cloud Account - Add Mode
 * Focused component for adding new AWS cloud accounts
 */
export const AWSCloudAccountAdd = ({
    formData,
    errors,
    onChange,
    onTestConnection,
    testing,
    tested,
    onDownloadTemplate,
    tags,
    onTagsChange,
    userOrg,
    setupAppliance,
    onSetupApplianceChange,
}) => {
    const isAWSPrivateDeployment = isAWS(getPrivateDeploymentCloud());

    return (
        <>
            <NameField value={formData.name} onChange={onChange('name')} error={errors.name} />

            {!isAWSPrivateDeployment && (
                <>
                    <UsernameField
                        value={formData.username}
                        onChange={onChange('username')}
                        label="Role"
                        placeholder="Enter Role (required)"
                        tooltip="Enter the Amazon Resource Name (ARN) associated with the role created to perform migration(s)."
                        error={errors.username}
                        required={true}
                    />

                    {/* AWS Helper Links */}
                    <div className="aws-helper-links">
                        Get role ARN using CloudFormation
                        <br />
                        <a
                            href={getHelpLink('AWS_ROLE_MANUAL_DOCS_LINK')}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="aws-link"
                        >
                            View Instructions
                        </a>
                        {' | '}
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                onDownloadTemplate('aws');
                            }}
                            className="aws-link"
                        >
                            Download Template
                        </a>
                    </div>
                </>
            )}

            {/* Test Connection */}
            <TestConnectionButton
                onTest={onTestConnection}
                testing={testing}
                tested={tested}
                error={errors.testing}
                label="Test connection"
                tooltip="As an option, you can test connection and role ARN before you continue."
                required={true}
            />

            {/* Tags */}
            <Form.Item label="Tags">
                <TagsSelector value={tags} onChange={onTagsChange} userOrg={userOrg} />
            </Form.Item>

            {/* Setup Appliance */}
            <Form.Item>
                <Checkbox checked={setupAppliance} onChange={(e) => onSetupApplianceChange(e.target.checked)}>
                    Setup Migration Appliance for this target cloud{' '}
                    <Tooltip title="A Migration Appliance must be deployed for each target. Leave this checked to setup the Migration Appliance after you complete this form.">
                        <QuestionCircleOutlined />
                    </Tooltip>
                </Checkbox>
            </Form.Item>
        </>
    );
};
